import React from 'react';
import Banner from './Components/banner';
import WedBan from '../../Assets/images/education-web/fine-ban1.png';
import { Col, Container, Row } from 'react-bootstrap';

import Fine1 from '../../Assets/images/education-web/fine-1.png';
import Fine2 from '../../Assets/images/education-web/fine-2.png';
import Fine3 from '../../Assets/images/education-web/fine-3.png';
import Fine4 from '../../Assets/images/education-web/fine-4.png';

import Earring from '../../Assets/images/education-web/earring.png';

import Brace1 from '../../Assets/images/education-web/brace-1.png';
import Brace2 from '../../Assets/images/education-web/brace-2.png';
import Brace3 from '../../Assets/images/education-web/brace-2.png';

import Ear1 from '../../Assets/images/education-web/ear-1.png';
import Ear2 from '../../Assets/images/education-web/ear-2.png';
import Ear3 from '../../Assets/images/education-web/ear-3.png';

import Help from './Components/help';
import Scrollspy from 'react-scrollspy';

import Loose from '../../Assets/images/education-web/loose.svg';
import Ring from '../../Assets/images/education-web/ring.svg';
import Gem from '../../Assets/images/education-web/gems.svg';
import Fine from '../../Assets/images/education-web/fine.svg';
import { Link } from 'react-router-dom';



const FineJewelryEducation = () => {
  return (
    <>
        <Banner title={'Fine Jewelry'} bannerImg={WedBan} nestedBreadCrumb  className="banner_fine"/>

        <div className='content-wrapper fine-jewelery'>
            <Container>
                <ul className='education-tabs'>
                    <li className=''>
                        <Link to="/education/loose-diamonds-education">
                            <img src={Loose} alt='' />
                            <h3>Loose Diamonds</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/engagement-ring-education">
                            <img src={Ring} alt='' />
                            <h3>Engagement Ring</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/gemstone-education">
                            <img src={Gem} alt='' />
                            <h3>Gemstones</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/wedding-ring-education">
                            <img src={Ring} alt='' />
                            <h3>Wedding Ring</h3>
                        </Link>
                    </li>

                    <li className='active'>
                        <Link to="/education/fine-jewelry-education">
                            <img src={Fine} alt='' />
                            <h3>Fine Jewelry</h3>
                        </Link>
                    </li>
                </ul>
            </Container>

            <Container>
                <h2 className='heading'>Table of Content</h2>
                <ul className='table-of-content mt-4'>
                    <li>
                        <a href="#section-1">
                            <h4>Necklace</h4>
                            <p>The perfect necklace or pendant will add style to anything she wears.</p>
                            <img src={Earring} alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="#section-2">
                            <h4>Bracelet</h4>
                            <p>A bracelet is one jewelry item she will see all the time, so she can appreciate it often.</p>
                            <img src={Earring} alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="#section-3">
                            <h4>Earring</h4>
                            <p>Earrings make the ideal blessing since they are consistently the correct fit.</p>
                            <img src={Earring} alt="" />
                        </a>
                    </li>
                </ul>
            </Container>

            <Row className='m-0 main-content'>
                <Col xl={2} className='p-0 d-xl-block d-none'>
                    <div className='sticky-breadcrumb px-5'>
                        <h4>Table of Content</h4>
                        <Scrollspy offset={200} items={ ['section-1', 'section-2', 'section-3', 'section-4'] } currentClassName="is-current">
                            <li><a href="#section-1">Necklace</a></li>
                            <li><a href="#section-2">Bracelet</a></li>
                            <li><a href="#section-3">Earring</a></li>
                        </Scrollspy>
                    </div>
                </Col>

                <Col xl={8} lg={12}>
                    <Container className=''>
                        <h2 className='heading mt-80' id="section-1">Necklace</h2>
                        <p>The perfect necklace or pendant will add style to anything she wears. In addition to being a stylish gift, giving her a necklace offers you the chance to perform the classically romantic gesture of putting it around her neck for the first time. In general, a necklace is defined as slightly type of chain or length of valuable metal or gems. They are also available in pendant styles that feature a single diamond, gemstone, fine metal design, or pearl, generally suspended from a chain. A pearl strand is a measurement of closely threaded pearls.</p>

                        <h2 className='sub-heading mt-50'>Necklace Type</h2>

                        <Row className='grid-section mt-40'>
                            <Col md={4} className='mb-md-0 mb-4 text-md-center text-left'>
                                <img className='mb-3' src={Fine1} alt='' />
                                <h2>Metal Chains</h2>
                                <p className='w-100'>Chains go with everything. A fine platinum chain in a choker length will add just a touch of luster.</p>
                            </Col>

                            <Col md={4} className='mb-md-0 mb-4 text-md-center text-left'>
                                <img className='mb-3' src={Fine2} alt='' />
                                <h2>Necklaces</h2>
                                <p className='w-100'>Necklaces come in a variety of styles including heavier chains, links, and braids. Some necklaces feature a fixed set of diamonds or gemstones, where others have stones that run their whole length.</p>
                            </Col>

                            <Col md={4} className='mb-md-0 mb-4 text-md-center text-left'>
                                <img className='mb-3' src={Fine3} alt='' />
                                <h2>Pearl strands</h2>
                                <p className='w-100'>Pearl strands are an important element to a woman's jewelry wardrobe. She can wear one with a dress to create a elegant look.</p>
                            </Col>

                            <Col md={4} className='mb-md-0 mb-4 text-md-center text-left'>
                                <img className='mb-3' src={Fine4} alt='' />
                                <h2>Solitaire Pendant</h2>
                                <p className='w-100'>The simple design of a solitaire pendant allows all the devotion to focus on a stunning diamond, pearl, or gemstone. These timeless pieces can be worn with a dress or with denims.</p>
                            </Col>
                        </Row>

                        <h2 className='mt-100 heading' id={'section-2'}>Bracelets</h2>
                        <p>A bracelet is one jewelry item she will see all the time, so she can appreciate it often. She also enjoys the feeling of it on her wrist reminding her of you.</p>
                        <p>Some bracelets are available in different lengths. So before you purchase, be sure to measure one of her other bracelets to be sure she doesn't need a special length.</p>
                        <p>Bracelets are usually worn on occasions when she isn't working with her hands. Even when not working, a bracelet's proximity to the hands causes it to get bumped and banged, so it must be very durable. Jewelry designers take this into account, so you can be sure the bracelet you choose will last.</p>

                        <h2 className='sub-heading mt-50' >Bracelet Type</h2>
                        <Row className='grid-section mt-40'>
                            <Col md={4} className='mb-md-0 mb-4 text-md-center text-left'>
                                <img className='mb-3' src={Brace1} alt='' />
                                <h2>Chains</h2>
                                <p className='w-100'>This is the exemplary bracelet. You'll discover an assortment of chain structures, similar to the conventional round-interface rolo or wheat chain, in an assortment of metals like sterling silver, 18k gold, and platinum.</p>
                            </Col>

                            <Col md={4} className='mb-md-0 mb-4 text-md-center text-left'>
                                <img className='mb-3' src={Brace2} alt='' />
                                <h2>Bangle</h2>
                                <p className='w-100'>A bangle bracelet can be worn for a basic look or can be joined with a few different bangles. Bangles draw the eye with metallic sparkle, and a few bangles clinking together make a wonderful sound.</p>
                            </Col>

                            <Col md={4} className='mb-md-0 mb-4 text-md-center text-left'>
                                <img className='mb-3' src={Brace3} alt='' />
                                <h2>Pearl</h2>
                                <p className='w-100'>A pearl bracelet is a traditional piece of jewelry. It adds a dressy touch to anything she wears, from pants to a party gown. Or on the other hand she can formalize the look with a coordinating pearl accessory and studs.</p>
                            </Col>
                        </Row>

                        <h2 className='mt-100 heading' id="section-3">Earrings</h2>
                        <p>Earrings make the ideal blessing since they are consistently the correct fit. The most essential gems closet piece, she may go out without a bracelet, however she's quite often wearing earrings.</p>
                        <p>Most earrings styles go with anything, adding style to anything she wears. The wide variety of earring types, sizes, and costs accessible makes it simple to find the ideal pair for a blessing. She'll remember you each time she wears them.</p>

                        <h2 className='sub-heading mt-50' >Earrings Type</h2>
                        <Row className='grid-section mt-40'>
                            <Col md={4} className='mb-md-0 mb-4 text-md-center text-left'>
                                <img className='mb-3' src={Ear1} alt='' />
                                <h2>Studs</h2>
                                <p className='w-100'>Since they're little, stud hoops are anything but difficult to wear. They go as effectively with a party dress as they do with pants. You'll discover an assortment of styles in Cultured Pearl Earrings, Diamond Earrings and Gemstone Earrings.</p>
                            </Col>

                            <Col md={4} className='mb-md-0 mb-4 text-md-center text-left'>
                                <img className='mb-3' src={Ear2} alt='' />
                                <h2>Drops</h2>
                                <p className='w-100'>Drop earrings are made to dangle underneath their setting. Swaying with movement, they can include an exquisite touch. Pearl, precious stone, and gemstone drop studs are accessible in different settings.</p>
                            </Col>

                            <Col md={4} className='mb-md-0 mb-4 text-md-center text-left'>
                                <img className='mb-3' src={Ear3} alt='' />
                                <h2>Hoops</h2>
                                <p className='w-100'>Platinum, gold, or silver hoops give a female touch, and valuable metals go with anything. For included shimmer, pick a couple with diamonds.</p>
                            </Col>
                        </Row>


                    </Container>
                </Col>
            </Row>
                

            <Container>
                <Help />
            </Container>
        </div>
    </>
    
  )
}

export default FineJewelryEducation;